import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiNotificationsCountVariables = Types.Exact<{ [key: string]: never; }>;


export type ApiNotificationsCount = { notificationsCount: number };



export const ApiNotificationsCountDocument = /*#__PURE__*/ `
    query NotificationsCount {
  notificationsCount
}
    `;

export const useNotificationsCount = <
      TData = ApiNotificationsCount,
      TError = ClientError
    >(
      variables?: ApiNotificationsCountVariables,
      options?: Omit<UseQueryOptions<ApiNotificationsCount, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiNotificationsCount, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiNotificationsCount, TError, TData>(
      {
    queryKey: variables === undefined ? ['NotificationsCount'] : ['NotificationsCount', variables],
    queryFn: apiFetcher<ApiNotificationsCount, ApiNotificationsCountVariables>(ApiNotificationsCountDocument, variables),
    ...options
  }
    )};

useNotificationsCount.getKey = (variables?: ApiNotificationsCountVariables) => variables === undefined ? ['NotificationsCount'] : ['NotificationsCount', variables];

export const useInfiniteNotificationsCount = <
      TData = InfiniteData<ApiNotificationsCount>,
      TError = ClientError
    >(
      variables: ApiNotificationsCountVariables,
      options: Omit<UseInfiniteQueryOptions<ApiNotificationsCount, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiNotificationsCount, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiNotificationsCount, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['NotificationsCount.infinite'] : ['NotificationsCount.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiNotificationsCount, ApiNotificationsCountVariables>(ApiNotificationsCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsCount.getKey = (variables?: ApiNotificationsCountVariables) => variables === undefined ? ['NotificationsCount.infinite'] : ['NotificationsCount.infinite', variables];


useNotificationsCount.fetcher = (variables?: ApiNotificationsCountVariables, options?: RequestInit['headers']) => apiFetcher<ApiNotificationsCount, ApiNotificationsCountVariables>(ApiNotificationsCountDocument, variables, options);
